import { NumberIndicator, NumberIndicatorProps } from './number-indicator';

export const DashboardIndicator = {
  Number: NumberIndicator as React.FC<NumberIndicatorProps>,
};
